import { Component, OnInit } from '@angular/core';
import frenchi18n from '@assets/i18n/fr.json';
import { BankDto } from '@core/service/digital-factory/bank/types/bankDto';
import { GetBanks } from '@core/usecase/getBanks';
import { environment } from '@environments/environment';
import { ProcessEventFactory } from '@shared/models/processEvents';
import { TrackerService } from '@shared/services/tracker.service';
import { ProcessEventService } from '@shared/services/process-event.service';
import { BankChoiceVM } from './bank-choice.viewmodel';

@Component({
  selector: 'app-bank-choice',
  templateUrl: './bank-choice.component.html',
  styleUrls: ['./bank-choice.component.scss'],
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'max-w-full d-flex flex-col justify-center items-center' },
})
export class BankChoiceComponent implements OnInit {
  isCancelPopinOpen = false;
  isShowingAllBanks = false;
  _searchTerm = '';

  private banks: BankDto[] = [];
  mostPopularBanks: BankDto[] = [];
  filteredBanks: BankDto[] = [];
  bankChoiceVM: BankChoiceVM;

  constructor(
    private getBanks: GetBanks,
    private processEventService: ProcessEventService,
    private tracker: TrackerService
  ) {
    this.bankChoiceVM = new BankChoiceVM();
  }

  async ngOnInit(): Promise<void> {
    this.tracker.trackPage({ taggingPage: 'BANK_CHOICE' });

    const result = await this.getBanks.execute();

    if (result.success === false) {
      this.processEventService.push(
        ProcessEventFactory.SpawnInternalErrorEvent({
          errorOrigin: 'BanksService - getBanks',
          error: result.reason,
        })
      );
    } else {
      this.setBanks(result.value);
    }
  }

  openCancelPopin() {
    this.tracker.trackClick({ click: frenchi18n.common_cancel, taggingPage: 'BANK_CHOICE' });
    this.isCancelPopinOpen = true;
  }

  closeCancelPopin() {
    this.isCancelPopinOpen = false;
  }

  setBanks(banks: BankDto[]) {
    this.banks = banks;
    this.filteredBanks = banks;
    this.mostPopularBanks = this.bankChoiceVM.findMostPopularBanks(this.banks);
  }

  showAllBanks() {
    this.tracker.trackClick({ click: frenchi18n.bank_choice_plus, taggingPage: 'BANK_CHOICE' });
    this.isShowingAllBanks = true;
  }

  resetSearchTerm() {
    this.searchTerm = '';
  }

  get searchTerm() {
    return this._searchTerm;
  }

  set searchTerm(term: string) {
    this._searchTerm = term;
    this.filteredBanks = this.banks.filter((bank) => bank.name.toLowerCase().includes(term.toLowerCase()));
  }

  selectBank(bankDto: BankDto) {
    this.tracker.trackClick({ click: `[Bank selected]: ${bankDto.name}`, taggingPage: 'BANK_CHOICE' });
    this.processEventService.push(ProcessEventFactory.SpawnBankChoiceEvent(bankDto));
  }

  isTestBankConnector(bankUid: string): boolean {
    return bankUid === environment.testBankConnector && environment.env !== 'prod';
  }
}
